import React, { FC, useRef, useState } from "react";
import LABELS from "../../../../constants/labels/pump.labels";
import html2canvas from "html2canvas";
import PumpChart from "./composite-curves";
import FlowRangeChart from "./performmance-curves";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import { usePumpFacade } from "../../../../facade/calculation/calculation-output/pump.facade";
import Accordion from "../../../common/accordion";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/ConfigureStore";
import TextShortInput from "../../../common/TextShortInput";

interface CompositePumpPlotProps { }

const CompositePumpPlot: FC<CompositePumpPlotProps> = () => {
  const { loading } = useAppSelector((state) => state?.pump);
  const PumpInputData = useSelector((state: RootState) => state.pump.PumpInput);
  const selectedPumpData = useSelector(
    (state: RootState) => state?.pump?.SelectedPump
  );
  const prodductionRate = useSelector(
    (state: RootState) => state?.pump.pmpChrtPrdRt
  );
  const productionRateUnit = useSelector(
    (state: RootState) => state?.pump?.pmpChrtPrdRtUnit
  );
  const PumpInputDataCalculated = useSelector(
    (state: RootState) => state.pump.PumpInputCalculated
  );
  const GasCalculationOutput = useSelector(
    (state: RootState) => state.gasCalculations.GasCalculationOutPut
  );
  const numberOfGasSeparator = useSelector(
    (state: RootState) => state.gasCalculations?.BasicGasCalculation?.noOfGasSeps
  )

  const FinalGasCalculationOutput = useSelector(
    (state: RootState) => state.gasCalculations.GasFinalCalculatedData
  );


  const CompPumpInputCalculated = useSelector(
    (state: RootState) => state.pump.CompPumpInputCalculated
  );
  const fluidDetails = useSelector((state: RootState) => state.fluid);

  const targetFlowRateForPump = useSelector(
    (state: RootState) => state.gasCalculations.GasFinalCalculatedData
  );

  const gasData = useSelector(
    (state: RootState) => state.gasCalculations.BasicGasCalculation
  );
  const gkxCalculations = useSelector(
    (state: RootState) => state.gasHandler.GKXCalculationData
  )

  const basicGasCalculation = useSelector(
    (state: RootState) => state.gasHandler.BasicGasCalculation
  )

  const cp1Calculations = useSelector(
    (state: RootState) => state.gasHandler.CP1CalculationData
  )
  const cp2Calculations = useSelector(
    (state: RootState) => state.gasHandler.CP2CalculationData
  )
  const cp3Calculations = useSelector(
    (state: RootState) => state.gasHandler.CP3CalculationData
  )

  const ChargePumpGKXListSelected = useSelector(
    (state: RootState) => state.gasHandler.gasHandlerPumpName
  )

  const ChargePumpListSelected = useSelector(
    (state: RootState) => state.gasCalculations.chargePumpName
  )
  const ChargePumpList2Selected = useSelector(
    (state: RootState) => state.gasCalculations.chargePump2Name
  )
  const ChargePumpList3Selected = useSelector(
    (state: RootState) => state.gasCalculations.chargePump3Name
  )


  const schematicData = useSelector(
    (state: RootState) => state.calculations.schematicData
  );

  const tubingDetails = useSelector((state: RootState) => state.tubing);
  const {
    GKXCalculationData,
    CP1CalculationData,
    CP2CalculationData,
    CP3CalculationData,
  } = useAppSelector((state) => state?.gasHandler);
  const { BasicGasCalculation } = useAppSelector(((state: RootState) => state.gasCalculations));
  const [compositePumpPlotDetails, setCompositePumpPlotDetails] = useState({
    compositePumpPlotHandlerFactors: {
      flow: "100",
      head: "100",
      power: "100",
    },
  });
  const getCompositeGraphData = useSelector(
    (state: RootState) => state?.pump?.CompositeCurveData
  );
  const compositeChartRef = useRef<HTMLDivElement | null>(null);

  const { compositePumpPerformanceCurvesCollapse } = useAppSelector(
    (state) => state?.collapse
  );

  const { updateCompositePumpPerformanceCurvesCollapse } = useCollapseFacade();
  const { overrideCorrectionFactorsCompositeCurve } = usePumpFacade();

  const handleCollapseChange = (key: boolean) => {
    updateCompositePumpPerformanceCurvesCollapse(key);
  };

  const composteCurveChartDownload = () => {
    if (compositeChartRef.current) {
      html2canvas(compositeChartRef.current, {
        backgroundColor: "#384252",
      }).then((canvas) => {
        const imgUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = imgUrl;
        link.download = "Composite-Charts.png";
        link.click();
      });
    }
  };
  const handleCorrectionFactorsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event?.target;
    let inputValue = value?.split(" %")?.[0];
    let newValue = inputValue === "" ? "0" : inputValue;
    if (
      newValue !== "0" &&
      newValue.startsWith("0") &&
      !newValue.includes(".")
    ) {
      newValue = newValue.slice(1);
    }
    const isNumberField = [
      "flwCrrctnForPump",
      "hdCrrctnForPump",
      "pWRCrrctnForPump",
    ]?.includes(name);
    const validNumberRegex = /^\d*\.?\d*$/;
    if (newValue !== "" && validNumberRegex.test(newValue) && isNumberField) {
      setCompositePumpPlotDetails((prev) => {
        const newState = { ...prev };
        if (name === "flwCrrctnForPump") {
          newState.compositePumpPlotHandlerFactors = {
            ...newState.compositePumpPlotHandlerFactors,
            flow: newValue,
          };
        } else if (name === "hdCrrctnForPump") {
          newState.compositePumpPlotHandlerFactors = {
            ...newState.compositePumpPlotHandlerFactors,
            head: newValue,
          };
        } else if (name === "pWRCrrctnForPump") {
          newState.compositePumpPlotHandlerFactors = {
            ...newState.compositePumpPlotHandlerFactors,
            power: newValue,
          };
        }
        return newState;
      });
    }
    return;
  };

  const handleBlurCorrectionFactors = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const name = event.target.name;
    if (name === "flwCrrctnForPump") {
      overrideCorrectionFactorsCompositeCurve({
        flowCorrection: Number(
          compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.flow
        ),
        headCorrection: compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.head ?? 0,
        powerCorrection: compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.power ?? 0,
      });
    } else if (name === "hdCrrctnForPump") {
      overrideCorrectionFactorsCompositeCurve({
        flowCorrection: compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.flow ?? 0,
        headCorrection: Number(
          compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.head
        ),
        powerCorrection: compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.power ?? 0,
      });
    } else if (name === "pWRCrrctnForPump") {
      overrideCorrectionFactorsCompositeCurve({
        flowCorrection: compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.flow ?? 0,
        headCorrection: compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.head ?? 0,
        powerCorrection: Number(
          compositePumpPlotDetails?.compositePumpPlotHandlerFactors?.power
        ),
      });
    }
  };
  return (
    <Accordion
      title='Composite pump performance curve'
      isOpen={compositePumpPerformanceCurvesCollapse}
      onToggle={() =>
        handleCollapseChange(!compositePumpPerformanceCurvesCollapse)
      }
      content={
        <div className='p-4 height-[100px]'>{PumpInputData && CompPumpInputCalculated && fluidDetails && PumpInputDataCalculated && gasData && selectedPumpData && gasData && GasCalculationOutput &&
          <><div className='flex justify-center items-start  w-full mb-2'>
            <div className='flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-full'>
              <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                <label className='text-neutral-25 text-[14px] font-normal'>
                  {LABELS.totalPower}
                </label>
                <label className='text-neutral-25'>
                  {GKXCalculationData?.totalPower ||
                    CP1CalculationData?.totalPower ||
                    CP2CalculationData?.totalPower ||
                    CP3CalculationData?.totalPower ||
                    PumpInputDataCalculated?.hPOPPump}
                  <span className="ml-1">{PumpInputData?.actNamePump_HP3500}</span>
                </label>
              </div>
              <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                <label className='text-neutral-25'>
                  {LABELS.flowCorrection}
                </label>
                <div className='relative w-[150px]'>
                  {" "}
                <TextShortInput
                    className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                    name='flwCrrctnForPump'
                    onChange={handleCorrectionFactorsChange}
                    value={compositePumpPlotDetails?.compositePumpPlotHandlerFactors
                      ?.flow ||
                      CompPumpInputCalculated?.compositeFlowCorrectionFactor}
                  onBlur={handleBlurCorrectionFactors}
                  unit=" %"
                />
                </div>
              </div>
              <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                <label className='text-neutral-25'>
                  {LABELS.headCorrection}:
                </label>
                <div className='relative w-[150px]'>
                <TextShortInput
                    className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                    name='hdCrrctnForPump'
                    onChange={handleCorrectionFactorsChange}
                    value={compositePumpPlotDetails?.compositePumpPlotHandlerFactors
                      ?.head ||
                      CompPumpInputCalculated?.compositeHeadCorrectionFactor}
                  onBlur={handleBlurCorrectionFactors}
                  unit=" %"
                />
                </div>
              </div>
              <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                <label className='text-neutral-25'>
                  {LABELS.powerCorrection}
                </label>
                <div className='relative w-[150px]'>
                <TextShortInput
                    className='px-[10px] py-[5px] w-[150px] text-[16px] bg-transparent border-[1px] rounded-[8px] focus:outline-none text-neutral-25 border-darkcolor-400 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                    name='pWRCrrctnForPump'
                    onChange={handleCorrectionFactorsChange}
                    value={compositePumpPlotDetails?.compositePumpPlotHandlerFactors
                      ?.power ||
                      CompPumpInputCalculated?.compositePowerCorrectionFactor}
                  onBlur={handleBlurCorrectionFactors}
                  unit=" %"
                />
                </div>
              </div>
            </div>
          </div><div className={`scrollable  relative overflow-auto mt-2`}>
              <table className='min-w-full rounded-[8px] height-[100px] outline-[1px] table'>
                <thead style={{ background: "#253040" }}>
                  <tr>
                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                      <div className='flex items-center'>{LABELS.pumpName}</div>
                    </th>
                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                      <div className='flex items-center'>{LABELS.noOfStages}</div>
                    </th>
                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                      <div className='flex items-center'>
                        {LABELS.liftContribution}
                      </div>
                    </th>
                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                      <div className='flex items-center'>
                        {LABELS.powerContribution}
                      </div>
                    </th>
                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                      <div className='flex items-center'>{LABELS.intakeFlow}</div>
                    </th>
                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                      <div className='flex items-center'>{LABELS.gvfIntake}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                      {selectedPumpData?.pumpName}
                    </td>
                    <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                      {PumpInputData?.pump_DesrdStges}
                    </td>
                    <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                      {PumpInputDataCalculated?.pmpFinalTDH}
                      <span className="ml-1">{PumpInputData.actNamePump_RequiredTDH}</span>
                    </td>
                    <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                      {PumpInputDataCalculated?.hPOPPump}
                      <span className="ml-1">{PumpInputData?.actNamePump_HP3500}</span>
                    </td>
                    <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                      {targetFlowRateForPump?.preTFV}{" "}
                      <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span>
                    </td>
                    <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                      {targetFlowRateForPump?.FreeGasGvf}{" "}
                      {BasicGasCalculation?.actNameGas_FreeGas}
                    </td>
                  </tr>
                  {ChargePumpList3Selected && (
                    <tr>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{ChargePumpList3Selected}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{gasData?.chargePumpDesrdStge3}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{cp3Calculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{GasCalculationOutput?.CP3_HPRating} {PumpInputData?.actNamePump_HP3500}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{cp3Calculations?.targetFlowRate} <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                        {
                          ChargePumpList2Selected ? GasCalculationOutput?.CP2_FreeGas :
                            ChargePumpListSelected ? GasCalculationOutput?.CP1_FreeGas :
                              ChargePumpGKXListSelected ? GasCalculationOutput?.GKX_FreeGas :
                                Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                                  Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                                    Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                                      Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                        GasCalculationOutput?.Intake_FreeGas}
                        <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                      </td>
                    </tr>
                  )}
                  {ChargePumpList2Selected && (
                    <tr>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{ChargePumpList2Selected}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{gasData?.chargePumpDesrdStge2}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{cp2Calculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{GasCalculationOutput?.CP2_HPRating} {PumpInputData?.actNamePump_HP3500}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{cp2Calculations?.targetFlowRate} <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                        {ChargePumpListSelected ? GasCalculationOutput?.CP1_FreeGas :
                          ChargePumpGKXListSelected ? GasCalculationOutput?.GKX_FreeGas :
                            Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                              Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                                Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                                  Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                    GasCalculationOutput?.Intake_FreeGas}
                        <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                      </td>
                    </tr>
                  )}
                  {ChargePumpListSelected && (
                    <tr>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{ChargePumpListSelected}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{gasData?.chargePumpDesrdStge}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{cp1Calculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{GasCalculationOutput?.CP1_HPRating} {PumpInputData?.actNamePump_HP3500}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{cp1Calculations?.targetFlowRate}<span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                        {
                          ChargePumpGKXListSelected ? GasCalculationOutput?.GKX_FreeGas :
                            Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                              Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                                Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                                  Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                    GasCalculationOutput?.Intake_FreeGas}
                        <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                      </td>
                    </tr>
                  )}
                  {ChargePumpGKXListSelected && (
                    <tr>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{ChargePumpGKXListSelected}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{gkxCalculations?.desiredStages}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{gkxCalculations?.finalTDH} {PumpInputData?.actNamePump_RequiredTDH}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{GasCalculationOutput?.GKX_HPRating} {gasData?.actNameGas_ChargePumpHP}</td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>{gkxCalculations?.targetFlowRate} <span className="ml-1">{BasicGasCalculation?.actNameGas_TotalFluidVolume}</span></td>
                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                        {Number(numberOfGasSeparator) === 4 ? GasCalculationOutput?.SP4_FreeGas :
                          Number(numberOfGasSeparator) === 3 ? GasCalculationOutput?.SP3_FreeGas :
                            Number(numberOfGasSeparator) === 2 ? GasCalculationOutput?.SP2_FreeGas :
                              Number(numberOfGasSeparator) === 1 ? GasCalculationOutput?.SP1_FreeGas :
                                GasCalculationOutput?.Intake_FreeGas}
                        <span className="ml-1">{BasicGasCalculation?.actNameGas_FreeGas}</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div><div className='flex justify-between mt-[16px]'>
              <div></div>
              <div className='flex'>
                <button
                  onClick={composteCurveChartDownload}
                  className='ml-[16px] border-[1px] border-solid border-[#4A5463] py-[8px] px-[14px] inline-flex justify-center items-center gap-[8px] rounded-[8px] bg-transparent text-neutral-25'
                >
                  Export Composite Curves
                </button>
              </div>
            </div><div className='mb-[15px]' ref={compositeChartRef}>
              <div className='flex justify-between items-start p-4 gap-4 w-full'>
                {getCompositeGraphData && <FlowRangeChart data={getCompositeGraphData} />}
              </div>
              <div className='pl-8 w-full'>
              {getCompositeGraphData && <PumpChart data={getCompositeGraphData} />}
              </div>
            </div></>
        }
        </div>
      }
    />
  );
};

export default CompositePumpPlot;
